import { OpenFeature } from '@openfeature/react-sdk'
import { assignLocation } from './browserNavigation'

export const ADMIN_LOGIN_PATH = '/admin-login'
export const CUSTOMER_LOGIN_PATH = '/login'

// The OpenFeature client domain and the stytch-admin-auth-enabled flag key are
// inlined here rather than imported from @/features/open-feature. errorHelpers
// imports this module and that barrel imports errorHelpers (for its LaunchDarkly
// logger), so importing the barrel here closes a require cycle. The barrel also
// transitively pulls user.selectors -> taxConstants, whose module-init
// createIsSomeEnum() call then runs against a half-initialized typeHelpers and
// throws under Jest's CommonJS loader. Canonical definitions live in
// FEATURE_FLAG_KEYS.stytchAdminAuthEnabled and index.ts's OPEN_FEATURE_DOMAIN_NAME.
const OPEN_FEATURE_DOMAIN_NAME = 'openFeatureClient'
const STYTCH_ADMIN_AUTH_FLAG_KEY = 'stytch-admin-auth-enabled'

export const isAdminContext = (): boolean =>
  window.location.pathname.startsWith('/admin')

// Which login page can actually re-authenticate an admin depends on the auth
// path the backend runs (stytch-admin-auth-enabled): under Stytch, /admin-login
// (SSO); under Passport, /login — /admin-login's SSO would mint a Stytch cookie
// the Passport gate ignores, a dead end. The flag is an environment-level toggle
// (fixed admin-auth context on the backend, no per-user targeting), so the
// frontend read returns the same value the gate uses. Defaults to /admin-login
// (the flipped-on end state) if the flag can't be read.
export const resolveAdminReauthPath = (): string => {
  const stytchEnabled = OpenFeature.getClient(
    OPEN_FEATURE_DOMAIN_NAME
  ).getBooleanValue(STYTCH_ADMIN_AUTH_FLAG_KEY, true)
  return stytchEnabled ? ADMIN_LOGIN_PATH : CUSTOMER_LOGIN_PATH
}

export const redirectToAdminLogin = (): void => {
  const target = resolveAdminReauthPath()
  if (window.location.pathname === target) return

  // Carry the originally-requested path so the admin-login page can forward it
  // through SSO (see admin-login/index.tsx) and land the admin back on their
  // deep link after re-auth. Only /admin-login reads ?redirect=; the Passport
  // fallback (/login) does not, so leave that target bare.
  if (target === ADMIN_LOGIN_PATH) {
    const { pathname, search, hash } = window.location
    const deepLink = `${pathname}${search}${hash}`
    assignLocation(`${target}?redirect=${encodeURIComponent(deepLink)}`)
    return
  }

  assignLocation(target)
}
